module.exports = __webpack_public_path__ + "static/media/thesis.edcdd16e.jpg";